var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDream2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1603 54.7949C45.1272 54.7949 54.8283 45.0938 54.8283 33.1268C54.8283 21.1599 45.1272 11.4587 33.1603 11.4587C21.1933 11.4587 11.4922 21.1599 11.4922 33.1268C11.4922 45.0938 21.1933 54.7949 33.1603 54.7949Z",
    stroke: "url(#paint0_linear_6582_55685)",
    strokeWidth: 4.02407,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7033 15.792C52.1471 14.8985 56.2204 15.6058 57.6797 18.1334C60.6714 23.3153 51.5448 34.1855 37.2947 42.4128C23.0446 50.64 9.0674 53.1089 6.07567 47.927C4.36845 44.97 6.6074 40.1607 11.4927 35.0472",
    stroke: "url(#paint1_linear_6582_55685)",
    strokeWidth: 4.02407,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6582_55685",
    x1: 20.7726,
    y1: -7.1139,
    x2: 59.9514,
    y2: 11.0981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6582_55685",
    x1: 16.802,
    y1: 0.330366,
    x2: 55.857,
    y2: 27.5192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDream2);
export default __webpack_public_path__ + "static/media/icon-dream-2.79d747da9442660dd5c9d3aad715be58.svg";
export { ForwardRef as ReactComponent };